import { motion } from 'framer-motion';
import { Globe2, Truck } from 'lucide-react';
import { WHATWEDO } from '../constants/testIds';

export const WhatWeDo = () => (
  <section data-testid={WHATWEDO.section} className="relative bg-brand-surface py-20 sm:py-28 border-y border-brand-border/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <p className="font-mono text-xs uppercase tracking-widest text-brand-amber mb-3">What We Do</p>
      <h2 className="font-display font-extrabold uppercase tracking-tight text-brand-text text-3xl sm:text-4xl max-w-2xl">
        Bulk Wholesale Used Tires — Moved Right
      </h2>
      <p className="mt-4 max-w-2xl text-brand-muted text-base sm:text-lg">
        BulkUsedTires.com specializes in exporting full used tire containers internationally, plus full
        truckload volume domestically. Through our network of shipping and logistics partners, we arrange
        fast, efficient delivery of your container — 20ft or 40ft — anywhere it needs to go.
      </p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          data-testid={WHATWEDO.cardExport}
          className="relative rounded-2xl border border-brand-border overflow-hidden min-h-[16rem] group"
        >
          <img
            src="/images/brand/team-loading-truck.jpg"
            alt="BulkUsedTires.com crew loading a bulk tire export truck"
            className="absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-bg via-brand-bg/60 to-transparent" />
          <div className="relative z-10 h-full flex flex-col justify-end p-7 sm:p-8">
            <Globe2 className="w-7 h-7 text-brand-orange mb-4" />
            <h3 className="font-display font-bold text-xl sm:text-2xl text-brand-text uppercase">International Container Exports</h3>
            <p className="mt-2 text-brand-muted text-sm sm:text-base">
              Full 20ft &amp; 40ft used tire containers exported worldwide, delivered to the port of your choice,
              with complete documentation handled for you.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          data-testid={WHATWEDO.cardDomestic}
          className="relative rounded-2xl border border-brand-border overflow-hidden min-h-[16rem] group"
        >
          <img
            src="/images/brand/worker-rolling-tire.jpg"
            alt="BulkUsedTires.com warehouse team handling domestic truckload tire orders"
            className="absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-bg via-brand-bg/60 to-transparent" />
          <div className="relative z-10 h-full flex flex-col justify-end p-7 sm:p-8">
            <Truck className="w-7 h-7 text-brand-amber mb-4" />
            <h3 className="font-display font-bold text-xl sm:text-2xl text-brand-text uppercase">Domestic Full-Truckload Delivery</h3>
            <p className="mt-2 text-brand-muted text-sm sm:text-base">
              Need bulk volume stateside? We run full tractor-trailer loads domestically, delivered directly
              to your shop or storage location — bulk quantities only, never a small local run.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
